import * as ents from '@attain-apps/entities'
import type * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjsUtils from '@attain-apps/rxjs-utils'
import * as rxjs from 'rxjs'

import type { Plugin } from '../plugin'

/**
 * TODO:
 */
export const changePage = store.effects.create(
  <TTypeParams extends ec.models.TypeParams.Constraint>(
    feature: Plugin<TTypeParams>['feature'],
    plugin: Plugin<TTypeParams>,
  ) =>
    feature.actions.changePage.observe().pipe(
      rxjsUtils.latestFrom(
        action => ({
          action: rxjs.of(action),
          currentPage:
            feature.selectors.paginationSelectedPageNumber.asObservable,
          /** Used to calculate skip based on page and quantity */
          quantity: feature.selectors.paginationQuantity.asObservable,
        }),
        (
          data,
        ): data is typeof data & {
          quantity: NonNullable<typeof data.quantity>
        } => data.quantity !== undefined,
      ),
      rxjs.map(({ action, currentPage, quantity }) => {
        let desiredPage: number | undefined
        if (action.data.next) {
          desiredPage = currentPage + 1
        } else if (action.data.previous) {
          desiredPage = currentPage - 1
        } else {
          desiredPage = action.data.page
        }
        if (desiredPage === undefined) {
          // Nothing we can do here
          return store.effects.SKIP
        }
        return plugin.collection.plugins.currentListPlugin.appliedParams.actions.setSkip
          .from(action)
          .create(
            ents.core.common.Request.For.Pagination.ByPosition.getSkip({
              pageNumber: desiredPage,
              quantity: quantity,
            }),
          )
      }),
    ),
)
